import { React, useState, useEffect, useContext } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import { CheckboxTable } from "../../view/CheckboxTable";
import { useValidateTableHelper } from "./useValidateTableHelper";
import ValidateHeaderMenuItem from "./ValidateHeaderMenuItem";
import ValidateTableRow from "./ValidateTableRow";
import ValidateTableRowSkeleton from "./ValidateTableRowSkeleton";
import { TableContext } from "../../index";

function ValidateTable({ validationResultList }) {

    const helper = useValidateTableHelper();
    const { config } = useContext(TableContext);


    let dataColumns = [
        { name: 'NOTES', state: true },
        { name: 'RULE NAME', state: true, sortKey: 'rule', onClick: () => helper.onRuleNameClick() },
        { name: 'DESCRIPTION', state: true, sortKey: 'details', onClick: () => helper.onDetailsClick() },
        { name: 'COMPLIANCE', state: false },
        { name: 'SECTION', state: false, sortKey: 'sectionName', onClick: () => helper.onSectionClick() },
        { name: 'SUBSECTION', state: false, sortKey: 'subsectionName', onClick: () => helper.onSubsectionClick() },
        // {name: 'EXPECTED RESULT',state:false, onClick: () => helper.onExpectedResultClick()},
        { name: 'DATE', state: true, sortKey: 'startTime', onClick: () => helper.onDateClick() },
        { name: 'CREATED BY', state: false, sortKey: 'user', onClick: () => helper.onUserClick() },
        { name: 'SEVERITY', state: true, sortKey: 'severity', onClick: () => helper.onSeverityClick() },
        { name: 'VALID', state: true, sortKey: 'valid', onClick: () => helper.onValidClick() },
        { name: 'GROUP', state: true, onClick: () => helper.onGroupClick() }
    ]

    let [data2, setData2] = useState(
        dataColumns.filter(column => column.state !== true).map(column => column.name)
    );//will contain the hidden headers name only coming from validateheadermenuitem component

    const sendHiddenHeaders = (hiddenheaderFromMenu) => {
        setData2([...hiddenheaderFromMenu]);
        //alert(data2+" //// "+hiddenheaderFromMenu);
    }

    let [data3, setData3] = useState(dataColumns);//contains same dataColumns name but differ in state

    const sendUpdatedDataColumns = (updatedDataColumns) => {
        setData3(updatedDataColumns);
    }

    let options = [{
        name: <><ValidateHeaderMenuItem updatedHiddenHeaders={data2} sendHiddenHeaders={sendHiddenHeaders} dataColumns={data3} sendUpdatedDataColumns={sendUpdatedDataColumns} /></>,
        className: "oct_table-actions-cell-v2"
    }]


    //const [remainedHeaders,setRemainedHeaders]=useState(headers);

    const getRemainedHeaders = () => {//to set the headers left after hiding others        
        let temp = data3.filter(obj => {
            return obj.state !== false;
        });
        let newHeaders = [...temp, ...options];
        return newHeaders;
    }


    const getHiddenHeaders = () => {//used this method to get the hiddenHeaders because data2 value is keep reseting        
        let temp = data3.filter(obj => {
            return obj.state !== true;
        });
        temp = temp.map(e => e.name);
        return temp;
    }

    useEffect(() => {
        ////////set the columns that has by default state=false as hidden like ('Expected Result')
        for (let i = 0; i < data3.length; i++) {
            if (data3[i].state === false && !data2.includes(data3[i].name)) {
                setData2([...data2, data3[i].name]);
            }
        }
    }, [data3, data2])

    // Client-side search filtering
    const searchTerm = (config.searchTerm || '').toLowerCase();
    const filteredList = searchTerm
        ? validationResultList.filter(item => {
            const rule = (item.rule || '').toLowerCase();
            const details = (item.details || '').toLowerCase();
            const compliance = (item.compliance || '').toLowerCase();
            const sectionName = (item.sectionName || '').toLowerCase();
            const subsectionName = (item.subsectionName || '').toLowerCase();
            const user = (item.user || '').toLowerCase();
            const severity = (item.severity || '').toLowerCase();
            const note = (item.note || '').toLowerCase();
            return rule.includes(searchTerm) || details.includes(searchTerm) ||
                compliance.includes(searchTerm) || sectionName.includes(searchTerm) ||
                subsectionName.includes(searchTerm) || user.includes(searchTerm) ||
                severity.includes(searchTerm) || note.includes(searchTerm);
        })
        : validationResultList;


    return (
        <>
            <CheckboxTable className="oct_validate-table-v2" headers={getRemainedHeaders()} elements={filteredList} containsEditButton={false} >
                {config.isLoading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <ValidateTableRowSkeleton key={index} index={index} hiddenHeaders={getHiddenHeaders()} />
                    ))
                ) : (
                    filteredList.map((data, index) => <ValidateTableRow key={index} data={data} index={index} hiddenHeaders={getHiddenHeaders()} />)
                )}
            </CheckboxTable>
            {!config.isLoading && filteredList.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    );
}

function mapStateToProps(state) {
    debug("ValidateTable mapStateToProps", state);
    const validatePage = state.validatePage;
    return {
        validationResultList: validatePage.validationResultList || []
    };
}

export default connect(mapStateToProps)(ValidateTable);
